import { AppConfigFields } from "../../types/appConfigEntities";

const DEFAULT_DISCOUNTS = window.APP_CONFIG?.[AppConfigFields.Discounts] ?? [
    { percent: "10% OFF", threshold: "$600.000" },
    { percent: "15% OFF", threshold: "$1.500.000" },
    { percent: "20% OFF", threshold: "$2.000.000" },
];

  export const carouselData = [
      // SLIDE BANNER (sin imagen y sin link)
      {
          type: "banner" as const,
          autoplayDelayMs: 12000,
          title: "MAYORISTA DE JOYAS Y ACCESORIOS",
          minPurchase: "$150.000",
          discountsTitle: "DESCUENTOS",
          discounts: DEFAULT_DISCOUNTS,
          ctaText: "Shop online",
          locationText: "Local: Uriburu 384 - CABA",
      },
    {
      image: "carrusel-1.jpeg",
      title: "LINEA EXCLUSIVA",
      link: "/categoria/anillos1"
    },
    {
      image: "carrusel-2.jpeg",
      title: "ACERO DORADO",
        link: "/categoria/acero-quirurgico-blanco"
    },
    {
      image: "carrusel-3.jpeg",
      title: "ACERO BLANCO",
      link: "/categoria/acero-dorado"
      },
    {
      image: "carrusel-4.jpeg",
      title: "ACERO BLANCO",
        link: "/categoria/hilo-y-acero"
    },
    {
      image: "carrusel-5.jpeg",
      title: "ANILLOS ACERO BLANCO",
      link: "/categoria/anillos1"
    },
    
  ];

  export const categoryImages = {
    mainImage: {
      src: "images/categorias-1/categoria3.png",
      alt: "Categoría 3",
      title: "Acero Quirúrgico Blanco",
      link: "/categoria/acero-quirurgico-blanco"
    },
    topImage: {
      src: "images/categorias-1/categoria2.png",
      alt: "Categoría 2",
      title: "Acero Dorado",
      link: "/categoria/acero-dorado"
    },
    bottomLeftImage: {
      src: "images/categorias-1/categoriasmall4.png",
      alt: "Categoría Small 4",
      title: "Acero Quirúrgico",
      link: "/categoria/acero-quirurgico"
    },
    bottomRightImage: {
      src: "images/categorias-1/categoriasmall1.png",
      alt: "Categoría Small 1",
      title: "PENDIENTES CHARMS",
      link: "/categoria/pulseras-charms"
    }
  };














